import { ArrowUp } from "lucide-react";
import { HMark } from "@/components/Monogram";
import { CHANNELS } from "@/components/Contact";
import { scrollToTarget } from "@/lib/scroll";

export const Footer = () => (
  <footer className="border-t border-line pt-24" data-testid="site-footer">
    <div className="container-x">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <p className="font-serif text-4xl font-light italic leading-tight text-ivory sm:text-5xl">
            Crafted with intention.<br />Built to last.
          </p>
        </div>
        <div className="flex flex-col gap-4 lg:col-span-3 lg:col-start-10">
          <span className="eyebrow">Elsewhere</span>
          {CHANNELS.filter((c) => c.id !== "email").map(({ id, label, href }) => (
            <a key={id} href={href} target="_blank" rel="noopener noreferrer" className="link-line w-fit text-ash hover:text-ivory" data-testid={`footer-link-${id}`}>
              {label}
            </a>
          ))}
        </div>
      </div>
      <div className="mt-24 flex items-end justify-between gap-6 border-b border-line pb-8">
        <div className="flex items-center gap-4 sm:gap-6">
          <HMark className="h-10 w-10 sm:h-16 sm:w-16" />
          <span className="wordmark text-5xl font-light text-ivory sm:text-8xl lg:text-[9rem] leading-none" data-testid="footer-wordmark">Hades</span>
        </div>
        <button
          onClick={() => scrollToTarget("#top")}
          className="group flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-line text-ash transition-colors duration-500 hover:border-gold hover:text-gold"
          aria-label="Back to top"
          data-testid="footer-back-to-top"
        >
          <ArrowUp size={18} className="transition-transform duration-500 group-hover:-translate-y-1" />
        </button>
      </div>
      <div className="flex flex-col gap-3 py-8 font-mono text-xs uppercase tracking-[0.2em] text-ash sm:flex-row sm:justify-between">
        <span>Designed &amp; Developed by Hades</span>
        <span data-testid="footer-year">© {new Date().getFullYear()} Hades</span>
      </div>
    </div>
  </footer>
);
